var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AIButton } from '@web/components/layout/AIInsights/AIButton';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import { Widget } from '@web/components/layout/Widget';
import { TimelineSingleDay } from '@web/components/ui/charts/Timeline';
import { trpc } from '@web/lib/trpc';
import { getTitleForMeeting, isAiButtonDisabled } from '@web/utility';
import { toISODate } from '@web/utility/date';
import { getChatEventDisplayTitle } from '@web/utility/eventsLogUtils';
import { ApplicationEnum, InsightTypeEnum } from '@workalizer/shared/enums';
import { addMinutes, format } from 'date-fns';
import { useTranslation } from 'react-i18next';
export var getEventForTimeLine = function (data, t) {
    var _a;
    return (_a = data === null || data === void 0 ? void 0 : data.map(function (event) {
        var _a, _b;
        var applicationName = event.applicationName;
        var startDate = new Date(event.startDate);
        var endDate = new Date((_a = event.endDate) !== null && _a !== void 0 ? _a : addMinutes(startDate, 1));
        var getTitle = function () {
            var _a, _b, _c, _d, _e, _f;
            switch (applicationName) {
                case ApplicationEnum.CALENDAR:
                    return (_b = (_a = event.calendarEvent) === null || _a === void 0 ? void 0 : _a.calendar) === null || _b === void 0 ? void 0 : _b.title;
                case ApplicationEnum.MEET:
                    if ((_c = event.meetingsEvent) === null || _c === void 0 ? void 0 : _c.meeting)
                        return getTitleForMeeting(event.meetingsEvent.meeting);
                    return null;
                case ApplicationEnum.DRIVE:
                    return (_e = (_d = event.documentEvent) === null || _d === void 0 ? void 0 : _d.document) === null || _e === void 0 ? void 0 : _e.title;
                case ApplicationEnum.CHAT:
                    return getChatEventDisplayTitle(event);
                case ApplicationEnum.GEMINI:
                    return (_f = event.geminiEvent) === null || _f === void 0 ? void 0 : _f.appName;
                case ApplicationEnum.GMAIL:
                    return null;
                default:
                    return null;
            }
        };
        var title = (_b = getTitle()) !== null && _b !== void 0 ? _b : event.title;
        var actionTitle = applicationName === ApplicationEnum.GEMINI
            ? 'app.workPatterns.timeline.action.GEMINI_USAGE'
            : "app.workPatterns.timeline.action.".concat(event.action);
        return {
            startDate: startDate,
            endDate: endDate,
            title: title ? "".concat(t(actionTitle), ": ").concat(title) : t(actionTitle),
            id: event.id,
            type: applicationName,
            action: event.action
        };
    })) !== null && _a !== void 0 ? _a : [];
};
export var DailyTimeline = function (_a) {
    var userId = _a.userId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, events = _a.events;
    var t = useTranslation().t;
    var gmailData = trpc.userTimeline.useQuery({
        userId: userId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }, {
        enabled: !events
    });
    var data = events || gmailData.data;
    var items = getEventForTimeLine(data || [], t);
    return (_jsx(Widget, __assign({ title: "".concat(format(new Date(dateFrom), 'MMM dd yyyy')), titleAction: _jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx(ExportMenu, { fileName: t('app.workPatterns.timeline.dailyTimeline'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, (data !== null && data !== void 0 ? data : []).map(function (event) {
                                    var _a;
                                    var _b, _c, _d, _e;
                                    var applicationName = event.applicationName;
                                    var title = (_d = (_c = (_b = getEventForTimeLine([event], t)[0]) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : event.title) !== null && _d !== void 0 ? _d : '';
                                    return _a = {},
                                        _a[t('export.date')] = toISODate(new Date(dateFrom)),
                                        _a[t('export.startTime')] = format(new Date(event.startDate), 'HH:mm'),
                                        _a[t('export.endTime')] = format(new Date((_e = event.endDate) !== null && _e !== void 0 ? _e : addMinutes(new Date(event.startDate), 1)), 'HH:mm'),
                                        _a[t('export.app')] = t("app.workPatterns.timeline.legend.".concat(applicationName)),
                                        _a[t('export.event')] = title,
                                        _a;
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(items) }), _jsx(AIButton, { insightsData: items, insightType: InsightTypeEnum.dailyTimeline, refetch: gmailData.refetch })] })) }, { children: _jsx(TimelineSingleDay, { data: { items: items }, fullDay: true, eventsLogContext: { userId: userId, dayDate: dateFrom } }) })));
};
